<template>
 <section>
    <LoadingSpinner v-if="!completeLoading" />
    <div class="mx-3 px-0" v-else>
      <div class="container-fluid w-100 mb-5 p-3 border bg-white rounded">
        <div class="d-flex flex-wrap">
          <template v-for="header in columns">
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">{{ $t("lang.column." + header.id) }}</span>
              </div>
              <input v-if="!header.id.match(/date/)" type="text" class="form-control" :aria-label="header.id" aria-describedby="inputGroup-sizing-sm" v-model="form[header.id]">
              <input v-else type="date" class="form-control" :aria-label="header.id" aria-describedby="inputGroup-sizing-sm" v-model="form[header.id]">
            </div>
          </template>
          <div class="w-25 p-1 ml-auto">
            <button class="btn btn-primary w-100 p-0" style="height: 100%;" @click="search(0)">Search</button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger h4" role="alert">
        <i data-v-7d622f5c="" class="icon-warning"></i> Error, please try again …
      </div>
      <LoadingSpinner v-if="tableLoading" />
      <div v-else-if="total > 0 && !error">
        <nav class="mb-2">
          <ul class="pagination w-100 justify-content-end">
            <li class="page-item disabled">
              <a class="page-link">Total: <span class="font-weight-bold">{{ total }}</span></a>
            </li>
            <li class="page-item disabled">
              <a class="page-link">Page:</a>
            </li>
            <template v-for="page in pages">
              <li v-if="isNaN(page.page)" class="page-item font-weight-bold disabled"><a class="page-link">{{ page.page }}</a></li>
              <li v-else-if="page.page == currentPage" class="page-item active"><a class="page-link" href="#" @click="search()">{{ page.page + 1 }}</a></li>
              <li v-else class="page-item"><a class="page-link" href="#" @click="search(page.page)">{{ page.page + 1}}</a></li>
            </template>
          </ul>
        </nav>
        <table class="table table-striped table-bordered table-hover table-sm" v-if="table.length > -1">
          <thead>
            <tr>
              <td v-for="header in columns">
                {{ $t("lang.column." + header.id) }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in table">
              <td v-for="header in columns" v-if="header.id in row">
                {{ row[header.id] }}
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
 </section>
</template>
<script>
import { delivrabilityService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default ({
  components: {
    LoadingSpinner
  },
  data(){
    return{
        error: false,
        completeLoading: false,
        tableLoading: false,
        table: [],
        total: 0,
        currentPage: 201,
        pageSize: 25,
        form: {},
        columns:[
          {id: 'test_date'},
          {id: 'client'},
          {id: 'prospector_email'},
          {id: 'prospector_provider'},
          {id: 'test_email'},
          {id: 'test_email_provider'},
          {id: 'send_protocol'},
          {id: 'ip'},
          {id: 'result'}
         ]
    }
  },
  mounted(){
    this.init()
  },
  props: {
  },
  watch: {
  },
  computed: {
    pages() {
      const totalPages = Math.ceil(this.total/this.pageSize);
      let currentPage = this.currentPage;
      let pages = []
      
      if(currentPage -2 > 0){
        pages.push({page: 0});
        if(currentPage > 3) pages.push({page: 1});
        if(currentPage > 4) pages.push({page: 2});
        if(currentPage > 5) pages.push({page: '…'});
      }

      let i = currentPage - 2;
      while(i<currentPage+3 && i<totalPages){
        if(i>-1){
          pages.push({page: i});
        }
        i++
      }

      if(i<totalPages){
        if(i<totalPages-3) pages.push({page: '…'});
        if(i<totalPages-2) pages.push({page: totalPages-3});
        if(i<totalPages-1) pages.push({page: totalPages-2});
        pages.push({page: totalPages-1});
      }

      return pages;      
    }
  },
  methods:{
    init(){
      this.completeLoading = true;
    },
    search(page){
      this.tableLoading = true;
      this.error = false;
      this.currentPage = page;
      let params = {offset: page * this.pageSize, pageSize: this.pageSize};
      Object.keys(this.form).filter(k => this.form[k].length > 0).map(k => params[k] = this.form[k]);
      delivrabilityService.getDelivrability(params).then((result) => {
        this.table = result.data;
        this.total = result.total;
        this.tableLoading = false;
      }).catch((err) => {
        this.error = true;
        this.tableLoading = false;
      });
    }
  }
})
</script>
